import Vue from 'vue';
import VueLazyload from 'vue-lazyload';


// Vue.component('the-header', require('./components/layouts/TheHeader.vue'))
// Vue.component('the-main', require('./components/Main.vue'))
// Vue.component('the-sidebar', require('./components/layouts/TheSidebar.vue'))

window.Vue = Vue;
window.Bus = new Vue;

 Vue.use(VueLazyload, {
 	lazyComponent: true,
 	loading: '/images/spinner.gif'
 });

require('./bootstrap');
require('./scroll');


const app = new Vue({
	el: '#app'
})


// WEBPACK FOOTER //
// ./resources/js/app.js